import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { alpha, createTheme } from '@mui/material/styles';
import { PROMETHEAN_FOCUS_SHADOW, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_MID_GREY, PROMETHEAN_NEUTRAL_PLUM, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_NEUTRAL_GREY_600, PROMETHEAN_NEUTRAL_GREY_800, PROMETHEAN_NEUTRAL_GREY_1000, PROMETHEAN_MID_PURPLE, PROMETHEAN_TEXT } from '../styles/colors/colors';
import { prometheanFont } from '../styles/font/font';
import { PROMETHEAN_INNER_SHADOW } from '../styles/elevation/elevation';
import { SWITCH_FOCUS_VISIBLE_CLASS } from './baseSwitch';
export var ROOT_PREFIX = 'EmbersSwitch';
export var createSwitchTheme = function createSwitchTheme() {
  var _root;
  return createTheme({
    components: {
      MuiSwitch: {
        defaultProps: {
          disableRipple: true
        },
        styleOverrides: {
          root: (_root = {
            fontFamily: prometheanFont,
            width: 60,
            height: 40,
            padding: '12px 14px',
            '&+.MuiTypography-root': {
              marginLeft: -3
            }
          }, _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-start"), {
            '&+.MuiTypography-root': {
              marginLeft: 0,
              marginRight: -3
            }
          }), _defineProperty(_root, '&.' + SWITCH_FOCUS_VISIBLE_CLASS, {
            position: 'relative',
            '::after': {
              content: '" "',
              position: 'absolute',
              display: 'block',
              top: 11,
              right: 13,
              bottom: 11,
              left: 13,
              borderRadius: 32,
              boxShadow: PROMETHEAN_FOCUS_SHADOW,
              zIndex: 1,
              pointerEvents: 'none'
            }
          }), _root),
          colorPrimary: {
            color: PROMETHEAN_NEUTRAL_MID_GREY
          },
          track: _objectSpread({
            width: 32,
            height: 16,
            background: PROMETHEAN_NEUTRAL_GREY_600,
            opacity: 1,
            borderRadius: 32
          }, PROMETHEAN_INNER_SHADOW),
          thumb: {
            width: 14,
            height: 14,
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
            marginTop: 1,
            marginLeft: 1,
            backgroundColor: PROMETHEAN_NEUTRAL_WHITE
          },
          switchBase: {
            padding: 12,
            outline: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
              // not on touch devices
              '@media (hover: none)': {
                backgroundColor: 'transparent'
              },
              '&+.MuiSwitch-track': {
                backgroundColor: PROMETHEAN_NEUTRAL_GREY_800,
                opacity: 1
              }
            },
            '&:active': {
              backgroundColor: 'transparent',
              // not on touch devices
              '@media (hover: none)': {
                backgroundColor: 'transparent'
              },
              '&+.MuiSwitch-track': {
                backgroundColor: PROMETHEAN_NEUTRAL_GREY_1000,
                opacity: 1
              }
            },
            '&.Mui-checked': {
              color: PROMETHEAN_PURPLE_GRAPE,
              transform: 'translateX(18px)',
              '&+.MuiSwitch-track': {
                backgroundColor: PROMETHEAN_PURPLE_PLUM,
                opacity: 1
              },
              '&:hover': {
                backgroundColor: 'transparent',
                // not on touch devices
                '@media (hover: none)': {
                  backgroundColor: 'transparent'
                },
                '&+.MuiSwitch-track': {
                  backgroundColor: PROMETHEAN_PURPLE_GRAPE,
                  opacity: 1
                }
              },
              '&:active': {
                backgroundColor: 'transparent',
                // not on touch devices
                '@media (hover: none)': {
                  backgroundColor: 'transparent'
                },
                '&+.MuiSwitch-track': {
                  backgroundColor: PROMETHEAN_MID_PURPLE,
                  opacity: 1
                }
              }
            },
            '&:not(.Mui-checked)': {
              transform: 'translateX(2px)'
            },
            '&.Mui-disabled': {
              '.MuiSwitch-thumb': {
                backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
                '&:before': {
                  visibility: 'hidden'
                }
              },
              '&+.MuiSwitch-track': {
                // this is to get a cursor to show up as not-allowed
                //  even though the widget itself is not getting pointer events
                '::after': {
                  content: '" "',
                  position: 'relative',
                  display: 'block',
                  top: -5,
                  left: -5,
                  width: 'calc(100% + 10px)',
                  height: 'calc(100% + 10px)',
                  borderRadius: 32,
                  zIndex: 1,
                  cursor: 'not-allowed'
                },
                backgroundColor: PROMETHEAN_NEUTRAL_MID_GREY,
                opacity: 1
              },
              '&:hover': {
                backgroundColor: alpha(PROMETHEAN_NEUTRAL_DARK_GREY, 0)
              },
              '&:active': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0)
              }
            }
          }
        }
      }
    }
  });
};
var createFilterLeftIcon = function createFilterLeftIcon(color) {
  return "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(color), "\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 7.5C3 7.22386 3.22386 7 3.5 7H20.5C20.7761 7 21 7.22386 21 7.5C21 7.77614 20.7761 8 20.5 8H3.5C3.22386 8 3 7.77614 3 7.5ZM6 11.5C6 11.2239 6.22386 11 6.5 11H17.5C17.7761 11 18 11.2239 18 11.5C18 11.7761 17.7761 12 17.5 12H6.5C6.22386 12 6 11.7761 6 11.5ZM9.5 15C9.22386 15 9 15.2239 9 15.5C9 15.7761 9.22386 16 9.5 16H14.5C14.7761 16 15 15.7761 15 15.5C15 15.2239 14.7761 15 14.5 15H9.5Z\"/></svg>')");
};
var createFilterRightIcon = function createFilterRightIcon(color) {
  return "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(color), "\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10ZM13.8744 14.5815C12.8291 15.4664 11.4769 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 11.4769 15.4664 12.8291 14.5815 13.8744L19.8536 19.1464C20.0488 19.3417 20.0488 19.6583 19.8536 19.8536C19.6583 20.0488 19.3417 20.0488 19.1464 19.8536L13.8744 14.5815Z\"/></svg>')");
};
var createViewLeftIcon = function createViewLeftIcon(color) {
  return "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(color), "\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 6H20C20.5523 6 21 6.44772 21 7V11.5H15.5V6ZM14.5 6H9.5V11.5H14.5V6ZM14.5 12.5H9.5V18H14.5V12.5ZM15.5 18H20C20.5523 18 21 17.5523 21 17V12.5H15.5V18ZM8.5 6V11.5L3 11.5V7C3 6.44772 3.44772 6 4 6H8.5ZM8.5 12.5L3 12.5V17C3 17.5523 3.44772 18 4 18H8.5V12.5ZM2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7Z\"/></svg>')");
};
var createViewRightIcon = function createViewRightIcon(color) {
  return "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" width=\"24\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(color), "\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H19.5C19.7761 5 20 4.77614 20 4.5C20 4.22386 19.7761 4 19.5 4H4.5ZM4.5 9C4.22386 9 4 9.22386 4 9.5C4 9.77614 4.22386 10 4.5 10H19.5C19.7761 10 20 9.77614 20 9.5C20 9.22386 19.7761 9 19.5 9H4.5ZM4 14.5C4 14.2239 4.22386 14 4.5 14H19.5C19.7761 14 20 14.2239 20 14.5C20 14.7761 19.7761 15 19.5 15H4.5C4.22386 15 4 14.7761 4 14.5ZM4.5 19C4.22386 19 4 19.2239 4 19.5C4 19.7761 4.22386 20 4.5 20H19.5C19.7761 20 20 19.7761 20 19.5C20 19.2239 19.7761 19 19.5 19H4.5Z\"/></svg>')");
};
var filterLeftIcon = createFilterLeftIcon(PROMETHEAN_TEXT);
var filterLeftGreyIcon = createFilterLeftIcon(PROMETHEAN_NEUTRAL_DARK_GREY);
var filterLeftWhiteIcon = createFilterLeftIcon(PROMETHEAN_NEUTRAL_WHITE);
var filterRightIcon = createFilterRightIcon(PROMETHEAN_TEXT);
var filterRightGreyIcon = createFilterRightIcon(PROMETHEAN_NEUTRAL_DARK_GREY);
var filterRightWhiteIcon = createFilterRightIcon(PROMETHEAN_NEUTRAL_WHITE);
var viewLeftIcon = createViewLeftIcon(PROMETHEAN_TEXT);
var viewLeftGreyIcon = createViewLeftIcon(PROMETHEAN_NEUTRAL_DARK_GREY);
var viewLeftWhiteIcon = createViewLeftIcon(PROMETHEAN_NEUTRAL_WHITE);
var viewRightIcon = createViewRightIcon(PROMETHEAN_TEXT);
var viewRightGreyIcon = createViewRightIcon(PROMETHEAN_NEUTRAL_DARK_GREY);
var viewRightWhiteIcon = createViewRightIcon(PROMETHEAN_NEUTRAL_WHITE);
export var createTableSwitchTheme = function createTableSwitchTheme(type) {
  var _root2;
  return createTheme({
    components: {
      MuiSwitch: {
        defaultProps: {
          disableRipple: true
        },
        styleOverrides: {
          root: (_root2 = {
            padding: 0,
            width: 104,
            height: 32,
            borderRadius: 32,
            '& .MuiSwitch-switchBase': {
              padding: 0,
              '&.Mui-checked': {
                transform: 'translateX(48px)',
                color: PROMETHEAN_LIGHT_PURPLE,
                '&+.MuiSwitch-track': {
                  background: PROMETHEAN_NEUTRAL_WHITE,
                  opacity: 1
                },
                '.MuiSwitch-thumb': {
                  backgroundImage: type === 'filter' ? filterRightIcon : viewRightIcon
                }
              }
            },
            '.MuiSwitch-track': {
              boxSizing: 'border-box',
              height: 32,
              width: 104,
              backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
              border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM),
              borderRadius: 32,
              opacity: '1 !important',
              transition: '150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
              '&:before, &:after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 24,
                height: 24
              },
              '&:before': {
                left: 16,
                backgroundImage: type === 'filter' ? filterLeftIcon : viewLeftIcon
              },
              '&:after': {
                right: 16,
                backgroundImage: type === 'filter' ? filterRightIcon : viewRightIcon
              }
            },
            '& .MuiSwitch-thumb': {
              boxSizing: 'border-box',
              boxShadow: 'none',
              width: 56,
              height: 32,
              padding: 0,
              overflow: 'hidden',
              borderRadius: 32,
              border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM),
              backgroundColor: PROMETHEAN_NEUTRAL_PLUM,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: type === 'filter' ? filterLeftIcon : viewLeftIcon,
              transition: '150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
            }
          }, _defineProperty(_root2, '&.' + SWITCH_FOCUS_VISIBLE_CLASS, {
            position: 'relative',
            '.MuiSwitch-switchBase.Mui-checked.Mui-focusVisible': {
              transform: 'translateX(45px)',
              '.MuiSwitch-thumb': {
                backgroundPosition: 'center right 12px'
              }
            },
            '::after': {
              content: '" "',
              position: 'absolute',
              display: 'block',
              top: 2,
              right: 2,
              bottom: 2,
              left: 2,
              borderRadius: 32,
              boxShadow: PROMETHEAN_FOCUS_SHADOW,
              border: '1px solid ' + PROMETHEAN_NEUTRAL_WHITE,
              zIndex: 1,
              pointerEvents: 'none'
            },
            '.MuiSwitch-thumb': {
              width: 53,
              height: 26,
              marginTop: 3,
              marginLeft: 3,
              backgroundPosition: '12px center'
            },
            '.MuiSwitch-track': {
              width: 98,
              height: 26,
              marginTop: 3,
              marginLeft: 3
            }
          }), _defineProperty(_root2, '.Mui-disabled', {
            '.MuiSwitch-thumb': {
              backgroundColor: PROMETHEAN_NEUTRAL_DARK_GREY,
              borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
              backgroundImage: type === 'filter' ? filterLeftWhiteIcon : viewLeftWhiteIcon
            },
            '&+.MuiSwitch-track': {
              borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
              '&:after': {
                backgroundImage: type === 'filter' ? filterRightGreyIcon : viewRightGreyIcon
              }
            },
            '&.Mui-checked': {
              '.MuiSwitch-thumb': {
                backgroundImage: type === 'filter' ? filterRightWhiteIcon : viewRightWhiteIcon
              },
              '&+.MuiSwitch-track': {
                '&:before': {
                  backgroundImage: type === 'filter' ? filterLeftGreyIcon : viewLeftGreyIcon
                }
              }
            }
          }), _root2)
        }
      }
    }
  });
};